import { isValid, format, isBefore, isAfter, differenceInCalendarDays as differenceInCalendarDays$1 } from 'date-fns';

const getCorrectISO = (date) => {
    // ISO date from BE doesn't contain "T" char, need to add it manually to make ISO format correct
    let formattedDate = date.replace(' ', 'T');
    // ISO date from BE doesn't contain "Z" char, though returned date is saved in UTC
    // So, need to add "Z" manually to make ISO format correct
    const lastSymbol = formattedDate.charAt(formattedDate.length - 1);
    // Date
    if (lastSymbol !== 'Z') {
        formattedDate = `${formattedDate}Z`;
    }
    return formattedDate;
};
const isoToFormat = (date, dateFormat = 'dd/MM/yyyy') => {
    if (typeof date !== 'string')
        return null;
    const dateObject = new Date(getCorrectISO(date));
    if (!isValid(dateObject))
        return null;
    return format(dateObject, dateFormat);
};
const getTime = () => new Date().getTime();
const isDateBefore = (date, dateToCompare) => {
    if (!date || !dateToCompare)
        return false;
    return isBefore(new Date(date), new Date(dateToCompare));
};
const isDateAfter = (date, dateToCompare) => {
    if (!date || !dateToCompare)
        return false;
    return isAfter(new Date(date), new Date(dateToCompare));
};
const differenceInCalendarDays = (endDate, startDate) => {
    if (!endDate || !startDate)
        return 0;
    return differenceInCalendarDays$1(new Date(endDate), new Date(startDate));
};
const getTimezone = () => {
    const offsetInMinutes = new Date().getTimezoneOffset();
    const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
    const sign = offsetInMinutes > 0 ? '-' : '+';
    // format e.g.: '-3'
    return sign + hours;
};

export { differenceInCalendarDays, getCorrectISO, getTime, getTimezone, isDateAfter, isDateBefore, isoToFormat };
//# sourceMappingURL=date.js.map
